import React from "react";

/**
 * Product Highlights — custom label/value rows shown as a clean bullet list
 * with the label in bold, arranged vertically for easy scanning.
 */
export default function ProductHighlights({ highlights, className = "" }) {
  const rows = (highlights || []).filter(
    (h) => (h?.label || "").trim() || (h?.value || "").trim()
  );
  if (rows.length === 0) return null;

  return (
    <section className={`mt-8 ${className}`} data-testid="product-highlights">
      <h2 className="font-display text-lg md:text-xl font-bold tracking-tight text-zinc-900 mb-4">
        Product Highlights
      </h2>
      <ul className="space-y-3">
        {rows.map((h, i) => (
          <li
            key={`${h.label}-${i}`}
            className="flex gap-3 leading-relaxed"
            data-testid={`highlight-row-${i}`}
          >
            <span className="mt-[9px] w-1.5 h-1.5 rounded-full bg-[#FF5A1F] shrink-0" />
            <span className="text-sm md:text-base text-zinc-700">
              {(h.label || "").trim() && (
                <span className="font-bold text-zinc-900">{h.label.trim()}: </span>
              )}
              <span>{(h.value || "").trim()}</span>
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
